'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const Markup = renderWithRef('Markup', null, (t, o)=>{
    let { children: n } = t, p = _object_without_properties(t, [
        "children"
    ]);
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: new Set([
            'swan-markup'
        ]),
        props: p,
        children: n
    });
});
const UncustomizableMarkup = Markup;

export { Markup, UncustomizableMarkup };
